import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useWebsiteT } from '../hooks/use-website-t';

export interface UnsavedChangesDialogProps {
  readonly open: boolean;
  readonly onKeepEditing: () => void;
  readonly onDiscard: () => void;
  /**
   * Epic #228 P5 (UI/UX P2-2): copy that names what is missing (e.g. an
   * unfinished link), instead of the generic "Discard unsaved changes?".
   */
  readonly copy?: {
    readonly titleKey: string;
    readonly bodyKey: string;
    readonly discardKey: string;
  };
}

/**
 * "Discard unsaved changes?". Escape and a click outside mean "keep
 * editing": only the explicit button discards.
 */
export function UnsavedChangesDialog({
  open,
  onKeepEditing,
  onDiscard,
  copy,
}: UnsavedChangesDialogProps): React.JSX.Element {
  const { t } = useWebsiteT();
  return (
    <AlertDialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onKeepEditing();
      }}
    >
      <AlertDialogContent data-testid="unsaved-changes-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t(copy?.titleKey ?? 'admin.websiteTemplates.dialog.discardTitle')}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t(copy?.bodyKey ?? 'admin.websiteTemplates.dialog.discardBody')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="unsaved-keep-editing">
            {t('admin.websiteTemplates.dialog.keepEditing')}
          </AlertDialogCancel>
          <AlertDialogAction data-testid="unsaved-discard" onClick={onDiscard}>
            {t(copy?.discardKey ?? 'admin.websiteTemplates.dialog.discard')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
